import type { Messages } from '../en'

export const memories: Messages['memories'] = {
  title: 'Memórias',
  subtitle: 'O que os seus Smiths lembram, para você não precisar repetir.',
  loading: 'Carregando o que os seus Smiths lembram…',
  empty: 'Nada foi lembrado ainda. Conforme você trabalha, os Smiths vão percebendo como você gosta das coisas.',
  noSmithKeeping: 'Nenhum Smith está guardando memórias por enquanto.',
  emptyHere: 'Este Smith não aparece para você aqui.',
  showAll: 'Ver todos',
  filterBySmith: 'Mostrar memórias de',
  allSmiths: 'Todos os Smiths',

  yours: 'Suas',
  yoursSub: 'Só você vê estas, e só você decide sobre elas.',
  company: 'Da sua empresa',
  companySub: (name) => `Todo mundo na ${name} trabalha com estas. Quem cuida delas é o administrador.`,
  unavailable: 'Não foi possível carregar estas agora. Tente de novo em instantes.',
  listCut: 'Esta lista mostra só as memórias mais recentes deste Smith.',
  capacityNear:
    'A memória deste Smith está quase cheia. Quando encher, o que o Smith aprender vai aguardar antes de ser usado, e só dá para adicionar ou passar a usar uma memória depois que outra deixar de ser usada.',
  capacityFull:
    'A memória deste Smith está cheia. O que o Smith aprender agora fica aguardando antes de ser usado, e só dá para adicionar ou passar a usar uma memória depois que outra deixar de ser usada.',
  noneForSmith: 'Nada lembrado por este ainda.',

  waiting: 'Esperando você',
  inUse: 'Em uso',
  waitingCount: (n) => (n === 1 ? '1 esperando você' : `${n} esperando você`),
  savedOn: (when) => `Anotado ${when}`,

  kinds: {
    preference: 'Preferência',
    correction: 'Correção',
    decision: 'Decisão',
    procedure: 'Procedimento',
    fact: 'Fato',
    negative: 'Restrição'
  },

  use: 'Usar',
  useHint: 'Os seus Smiths passam a aplicar a partir da próxima execução.',
  discard: 'Descartar',
  discardHint: 'Os seus Smiths não vão aplicar. Uma execução futura ainda pode sugerir a mesma coisa de novo.',
  discardReasonLabel: 'Por que isso não deve ser usado?',
  discardReasonPlaceholder: 'Valia só para aquele pedido',
  discardReasonRequired: 'Diga o motivo, em poucas palavras.',
  stopUsing: 'Parar de usar',
  stopUsingHint: 'Os seus Smiths deixam de aplicar. Isso não pode ser desfeito.',
  reword: 'Reescrever',
  rewordHint: 'Salvar o seu texto também coloca em uso.',
  cancel: 'Cancelar',
  save: 'Salvar',
  confirm: 'Confirmar',
  working: 'Salvando…',

  titleLabel: 'Sua memória, em uma frase',
  titleHint: 'Obrigatório. Diga tudo em uma frase completa: é o que o seu Smith lê primeiro.',
  detailsLabel: 'Detalhes (opcional)',
  detailsHint: (inline) =>
    `Contexto, exemplos ou o motivo, não a continuação da frase acima. Deixe em branco quando a frase já diz tudo. O seu Smith lê detalhes de até ${inline.toLocaleString('pt-BR')} caracteres junto com a frase, e os mais longos quando precisar deles.`,
  count: (n, max) => `${n.toLocaleString('pt-BR')} / ${max.toLocaleString('pt-BR')} caracteres`,
  tooLong: (max) => `Os detalhes podem ter no máximo ${max.toLocaleString('pt-BR')} caracteres. Encurte para salvar.`,
  titleTooLong: (max) =>
    `A frase pode ter no máximo ${max.toLocaleString('pt-BR')} caracteres. Diga de forma mais curta; contexto e exemplos ficam nos detalhes.`,
  needsTitle: 'Escreva a sua memória em uma frase no primeiro campo. Os detalhes são opcionais.',
  showWhole: (n) => `Mostrar os ${n.toLocaleString('pt-BR')} caracteres`,
  showLess: 'Mostrar menos',

  write: 'Ensinar algo',
  writePlaceholder: 'Escreva do jeito que você diria',
  writeHint: 'Só você vê, e vale a partir da sua próxima execução. Dá para reescrever ou remover depois.',
  writeSave: 'Salvar',
  writeKindLabel: 'Que tipo de coisa é?',
  writeKinds: {
    preference: {
      label: 'Algo que eu prefiro',
      example: 'Me mande um resumo curto do que mudou antes do documento completo.'
    },
    prohibition: {
      label: 'Algo que nunca deve acontecer',
      example: 'Nunca cite preço em dólar em nada que você me mandar.'
    },
    fact: {
      label: 'Algo que ele precisa saber',
      example: 'Eu cuido da área de compras, então os meus pedidos são sobre compras.'
    }
  },
  writeExample: (example) => `Por exemplo: “${example}”`,

  homeTitle: (n) => (n === 1 ? 'Uma memória está esperando você' : `${n} memórias estão esperando você`),
  homeSubWithSmith: (name) => `O ${name} anotou algo sobre como você gosta de trabalhar.`,
  homeSub: 'Foi anotado algo sobre como você gosta de trabalhar.',
  homeCta: 'Revisar'
}
